import { Component, OnInit } from '@angular/core';
import { AnimeListService } from '../../services/anime-list.service';
import { Anime } from '../../models/core.model';
import { FormControl } from '@angular/forms';
import { Loader } from 'app/shared/loader/loader.component';
import { debounceTime, tap, startWith } from 'rxjs/operators';
import { LoaderService } from 'app/shared/loader/loader.service';

@Component({
  selector: 'app-anime-list',
  templateUrl: './anime-list.component.html',
  styleUrls: ['./anime-list.component.scss']
})
export class AnimeListComponent implements OnInit {
  aniList: Anime[];
  reset: Anime[];
  search = new FormControl('');
  idLoader = "loader_1";
  constructor(private aniService: AnimeListService, public loader: LoaderService) {
  }

  ngOnInit() {
    this.aniService.get().pipe(
      debounceTime(1000)
    ).subscribe(res => {
      this.aniList = res;
      this.reset = res;
    });

    this.search.valueChanges.pipe(
      tap((res) => this.loader.show(this.idLoader)),
      debounceTime(600)
    )
      .subscribe(val => {
        if (val == '' || val == null) {
          this.aniList = this.reset;
        } else {
          this.aniList = this.aniList.filter(a => a.Name.toLowerCase().includes(val.toLowerCase()));
        }
        this.loader.hide(this.idLoader);
      });
  }
}
